
import { Options, Vue } from 'vue-class-component';
import { FootwearEstimationClient } from '@/services/Services';
import AdditionalProperties from './components/additionalProperties.vue';
import * as OM from '@/Model';

@Options({
    components: {
        AdditionalProperties
    }
})
export default class Chemicals extends Vue {

    estimationIdentifier: string = "";
    chemicalsFromConfiguration: OM.FootwearAdditionalPropertiesConfiguration[] = [];
    estimationChemicals: OM.FootwearAdditionalProperty[] = [];

    loaded: boolean = false;
    
    created() {
        this.estimationIdentifier = this.$route.params.estimationIdentifier.toString();
        this.init();
    }

    init() {
        Promise.all([
            FootwearEstimationClient.getChemicalsFromConfiguration(),
            FootwearEstimationClient.getChemicalsAdditionalsFromEstimation(this.estimationIdentifier)
        ])
        .then( xs => {
            this.chemicalsFromConfiguration = xs[0];
            this.estimationChemicals = xs[1];

            setTimeout(() => {
                this.loaded = true;
            }, 300);
        })
    }

    updateAdditionalProperties(model: OM.FootwearEstimationAdditionalPropertyVM) {
        FootwearEstimationClient.updateAdditionalProperties(model)
        .then(x => {
            this.$router.push('/footwear-calculator/accessories/' + this.estimationIdentifier);
        })
    }
}
